module.exports = __webpack_public_path__ + "media/commencement-2022-fall.bd1dc311.mp4";